import React from 'react';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import LoginPage from './Components/ConfigurationPage/Pages/LoginPage/LoginPage';
import AdminPage from './Components/ConfigurationPage/Pages/AdminPage/AdminPage';
import UserPage from './Components/ConfigurationPage/Pages/UserPage/UserPage';
import MainPage from './Components/MainPage/MainPage';

const PrivateRoute = ({ children, roles }) => {
	const auth = useAuth();
	return auth.isLoggedIn && roles.includes(auth.role) ? (
		children
	) : (
		<Navigate to="/login" />
	);
};

function App() {
	return (
		<div className="App">
			<AuthProvider>
				<Router>
					<Routes>
						<Route path="/" element={<MainPage />} />
						<Route path="/login" element={<LoginPage />} />
						<Route
							path="/adminpage"
							element={
								<PrivateRoute roles={['admin']}>
									<AdminPage />
								</PrivateRoute>
							}
						/>
						<Route
							path="/userpage"
							element={
								<PrivateRoute roles={['user']}>
									<UserPage />
								</PrivateRoute>
							}
						/>
					</Routes>
				</Router>
			</AuthProvider>
		</div>
	);
}

export default App;
